export default {
  load_error_title: "Dokument konnte nicht geladen werden",
  load_error_subtitle:
    "Entschuldigung, das Dokument konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
};
